/**
 * supportChime — distinctive two-tone chime for Technical & Admin
 * Support replies (2026-07). Synthesized via Web Audio (no asset file).
 *
 * Browser autoplay policy: an AudioContext only runs after a user
 * gesture. `primeChimeOnGesture()` unlocks it on the first
 * click/keydown/touch so later chimes can play unattended.
 */
let _ctx = null;

const _ensureCtx = () => {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    if (!_ctx) _ctx = new AC();
    if (_ctx.state === 'suspended') _ctx.resume().catch(() => {});
    return _ctx;
  } catch (_e) {
    return null;
  }
};

let _primed = false;
export function primeChimeOnGesture() {
  if (_primed) return;
  _primed = true;
  const unlock = () => {
    _ensureCtx();
    document.removeEventListener('pointerdown', unlock);
    document.removeEventListener('keydown', unlock);
  };
  document.addEventListener('pointerdown', unlock, { once: true });
  document.addEventListener('keydown', unlock, { once: true });
}

/** Pleasant ascending A5→D6 "ding-dong". Returns true when audible. */
export function playSupportChime() {
  const ctx = _ensureCtx();
  if (!ctx || ctx.state !== 'running') return false;
  try {
    const now = ctx.currentTime;
    const master = ctx.createGain();
    master.gain.value = 0.14;
    master.connect(ctx.destination);
    [[880, 0], [1174.66, 0.18]].forEach(([freq, delay]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + delay);
      gain.gain.exponentialRampToValueAtTime(1, now + delay + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + delay + 0.9);
      osc.connect(gain);
      gain.connect(master);
      osc.start(now + delay);
      osc.stop(now + delay + 1);
    });
    return true;
  } catch (_e) {
    return false;
  }
}

// Exposed for E2E automation (audio itself can't be asserted headlessly).
try { window.__mespSupportChime = playSupportChime; } catch (_e) { /* SSR safety */ }
